<script>
  import { Router, Route } from "svelte-routing";

  import Layout2 from "./routes/Layout2/Layout_2.svelte";
  import Login from "./routes/login.svelte";
  import Signup from "./routes/signup.svelte";
  import Password_forgot from "./routes/password_forgot.svelte";

  export let url = "";
</script>

<Router {url}>
  <div>
    <Route path="/"><Layout2 /></Route>
    <Route path="/login"><Login /></Route>
    <Route path="/signup"><Signup /></Route>
    <Route path="/password_forgot"><Password_forgot /></Route>
  </div>
</Router>